String.prototype.toParamString = function (...params: string[]) {
  let result = this.toString();

  params.forEach((param, index) => {
    result = result.replace(`{${index}}`, param);
  });

  return String(result);
};

export default {
  OKTA: {
    TITLE: 'Une erreur technique est survenue.',
    MESSAGE: "Vous pouvez contacter Helpy et signaler l'erreur : {error}.",
  },
  UNKNOWN: {
    TITLE: 'Erreur inconnue',
    MESSAGE: 'Une erreur inconnue est survenue.',
  },
  NETWORK: {
    TITLE: 'Problème réseau',
    MESSAGE: 'Vérifiez que vous êtes bien connecté.',
  },
  HTTP: {
    _401: {
      TITLE: 'Utilisateur non reconnu',
      MESSAGE: 'Veuillez réessayer ou vérifiez vos droits d’accès à eTime.',
    },
    _403: 'Accès non autorisé',
    _404: 'Ressource introuvable',
    _409: 'Conflit',
    _500: 'Problème serveur',
  },
};
